export default "<span class=\"currency\" data-automation-id=\"currency-symbol\">&nbsp;{{getCurrency()}}</span>\n";